<template>
  <v-dialog
    class="modal"
    :retain-focus="false"
    origin="top"
    v-model="dialog"
    max-width="700"
    width="100%"
  >
    <v-btn
      class="modal-close-button"
      width="36px"
      height="36px"
      icon
      color="white"
      text
      @click="dialog = false"
    >
      <v-icon>fas fa-times</v-icon>
    </v-btn>

    <slot />
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: true,
  }),
  mounted() {
    this.$rest("informations")
      .get()
      .then(() => (this.loading = false));
  },
};
</script>

<style lang="scss" scoped>
.modal {
  &-close-button {
    position: absolute;
    top: 0;
    right: 0;
  }
}
</style>
